"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntersectionDetector = void 0;
var react_1 = __importStar(require("react"));
/*
* this component check if itself has passed through viewport
* setting rootMargin can shift the detect earlier
*/
function IntersectionDetector(props) {
    var onIntersect = props.onIntersect, rootMargin = props.rootMargin;
    var ref = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (typeof IntersectionObserver === 'undefined') {
            console.warn('IntersectionObserver is undefined');
            return;
        }
        var observer = new IntersectionObserver(function (entries) {
            // only observing one div
            if (entries[0].isIntersecting) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                onIntersect(ref.current);
            }
        }, 
        // options
        {
            rootMargin: rootMargin,
        });
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        observer.observe(ref.current);
        return function () {
            observer.disconnect();
        };
    }, [onIntersect, rootMargin]);
    return react_1.default.createElement("div", { ref: ref });
}
exports.IntersectionDetector = IntersectionDetector;
